import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=c10b238a"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c10b238a')) {
      api.createRecord('c10b238a', component.options)
    } else {
      api.reload('c10b238a', component.options)
    }
    module.hot.accept("./notification.vue?vue&type=template&id=c10b238a", function () {
      api.rerender('c10b238a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/badge/notification.vue"
export default component.exports